<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 头像 -->
        <el-form-item label="头像" prop="photo">
            <imgs-upload v-model="params.photo" @change="fileChange" tips="（推荐尺寸：400*400）" limit="1" />
        </el-form-item>
        <!-- 主页图 -->
        <el-form-item label="主页图" prop="homeChart">
            <imgs-upload v-model="params.homeChart" @change="fileChange" tips="（推荐尺寸：1920*600）" limit="1" />
        </el-form-item>

        <!-- 状态 -->
        <el-form-item label="社交账号" prop="status">
            <el-button @click="openSj" type="primary" size="small">添加账号</el-button>
            <el-table :data="params.lawyerSocialaccountsList" :header-cell-style="{background:'#F3F4F7',color:'#555'}" style="width: 70%" border>
                <el-table-column prop="platform" label="社交平台">
                </el-table-column>
                <el-table-column prop="account" label="社交账号" width="180">
                </el-table-column>
                <el-table-column prop="webUrl" label="网址" width="180">
                </el-table-column>
                <el-table-column prop="urlQrcode" label="账号二维码" width="180">
                </el-table-column>
                <el-table-column width="120" label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="delRow( scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-form-item>

    </el-form>
    <el-dialog title="新增社交" :visible.sync="dialogVisible" @closed="closedDialog" :close-on-click-modal="false" width="560px">
        <el-form :model="fromDialog" label-width="100px" label-position="right">
            <el-form-item label="社交平台">
                <dic-select code="sjpt" v-model="fromDialog.platformId" paramsKey="major" @change="selectChange" plaText="社交平台" />
            </el-form-item>
            <el-form-item label="账号名称">
                <el-input v-model="fromDialog.account" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="网址">
                <el-input v-model="fromDialog.webUrl" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="账号二维码">
                <imgs-upload :image="fromDialog.urlQrcode" @imgChange="imgChange" tips="（115*70推荐）" />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addDialog" size="small">确 定</el-button>
            <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    props: ['indata'],
    data() {
        return {
            dialogVisible: false,
            fromDialog: {
                id: '',
                webUrl: '', //地址
                urlQrcode: '', //二维码
                lawyerId: '', //lawyerId
                platform: '', //平台
                platformId: '',
                account: '', //账号
                teamId: '', //律师团队ID
                class_type: 'TJingshiLawyerSocialaccounts',
            },
            params: {
                photo: '', //照片头像
                homeChart: '', //主页图
                lawyerSocialaccountsList: [], //拥有社交账号
            },
            rules: {
                photo: [{
                    required: true,
                    message: '头像不能为空',
                    trigger: 'blur'
                }],
                homeChart: [{
                    required: true,
                    message: '头像不能为空',
                    trigger: 'blur'
                }],
            }
        }
    },
    watch: {
        indata: function (e) {
            console.log(e);
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
                this.handleClassType(this.params.lawyerSocialaccountsList, 'TJingshiLawyerSocialaccounts');
            }
        }
    },
    methods: {
        delRow(row) {
            for (var i = 0; i < this.params.lawyerSocialaccountsList.length; i++) {
                if (this.params.lawyerSocialaccountsList[i].platformId + this.params.lawyerSocialaccountsList[i].account === row.platformId + row.account) {
                    this.params.lawyerSocialaccountsList.splice(i, 1);
                }
            }
        },
        selectChange(e) {
            // console.log(e);
            this.fromDialog.platform = e.name;
        },
        addDialog() {
            var account = {
                webUrl: this.fromDialog.webUrl, //地址
                urlQrcode: this.fromDialog.urlQrcode, //二维码
                lawyerId: this.fromDialog.lawyerId, //lawyerId
                platform: this.fromDialog.platform, //平台
                platformId: this.fromDialog.platformId, //平台
                account: this.fromDialog.account, //账号
                teamId: this.fromDialog.teamId, //律师团队ID
                class_type: 'TJingshiLawyerSocialaccounts',
            };
            this.params.lawyerSocialaccountsList.push(account);
            this.dialogVisible = false;
        },
        openSj() {
            this.dialogVisible = true;
        },
        closedDialog() {
            this.fromDialog = {
                id: '',
                webUrl: '', //地址
                urlQrcode: '', //二维码
                lawyerId: '', //lawyerId
                platform: '', //平台
                platformId: '', //平台
                account: '', //账号
                teamId: '', //律师团队ID
                class_type: 'TJingshiLawyerSocialaccounts',
            };
        },
        handleClassType(arr, class_type) {
            if (arr) {
                for (var i = 0; i < arr.length; i++) {
                    if (!arr[i].hasOwnProperty('class_type')) {
                        arr[i]['class_type'] = class_type;
                    }
                }
            }
        },
        imgChange(e) {
            console.log(e);
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {

                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },
    created: function () {
        var vues = this;
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.params);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// subpage3.vue?1dc509a4